import request from 'components/Utils/Request';
import axios from 'axios';
const { REACT_APP_API_URL } = process.env;
export const CLIENT_REPORT_REQUEST= 'CLIENT_REPORT_REQUEST';
export const CLIENT_REPORT_SUCCESS = 'CLIENT_REPORT_SUCCESS';
export const CLIENT_REPORT_FAILURE = 'CLIENT_REPORT_FAILURE';
export const CLIENT_REPORT_PDF_REQUEST = 'CLIENT_REPORT_PDF_REQUEST';
export const CLIENT_REPORT_PDF_SUCCESS = 'CLIENT_REPORT_PDF_SUCCESS';
export const CLIENT_REPORT_PDF_FAILURE = 'CLIENT_REPORT_PDF_FAILURE';

  export const getClientReportRequest = () => ({
    type: CLIENT_REPORT_REQUEST
  });
  export const getClientReportSuccess = payload => ({
    type: CLIENT_REPORT_SUCCESS,
    payload
  });
  export const getClientReportFailure = payload => ({
    type: CLIENT_REPORT_FAILURE,
    payload
  });

    export const clientReportPDFRequest = () => ({
      type: CLIENT_REPORT_PDF_REQUEST
    });
    export const clientReportPDFSuccess = payload => ({
      type: CLIENT_REPORT_PDF_SUCCESS,
      payload
    });
    export const clientReportPDFFailure = payload => ({
      type: CLIENT_REPORT_PDF_FAILURE,
      payload
    });
  
  export const clientReportDataAction = payload => {
    return {
      type: 'CLIENTREPORTDATA',
      payload
    };
  };

  export const clientReportDetailAPI = (
    payload,
    successData,
    errorMSg,
    headers = {}
  ) => {
    return dispatch => {
      dispatch(getClientReportRequest());
      const url = `${REACT_APP_API_URL}/client-report-detail`;
      return request('POST', url, payload, '', headers)
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(getClientReportSuccess(res));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(getClientReportFailure('Something went wrong'));
          throw err;
        });
    };
  };
  
export const clientReportPdfAPI = (payload, successCallback, errorCallback, headers = {}) => {
  return dispatch => {
    dispatch(clientReportPDFRequest());
    axios
      .post(
        `${REACT_APP_API_URL}/client-report-detail`,
        payload,
        {
          responseType: 'blob',
          headers: headers,
        }
      )
      .then(response => {
        if (response.status === 200 && response.data) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl, '_blank');

          dispatch(clientReportPDFSuccess());
        } else {
          errorCallback("Failed to generate PDF");
          dispatch(clientReportPDFFailure());
        }
      })
      .catch(error => {
        console.error("Error downloading PDF:", error);
        errorCallback("Error occurred while downloading PDF");
        dispatch(clientReportPDFFailure());
      });
  };
};
